import React from 'react';
import classNameBind from 'classnames/bind';

import Icon from '../../../Icon';
import Label from '../../../Label';
import styles from './MenuSidebarElement.module.css';
import Badge from '../../../Badge';

const bindClasses = classNameBind.bind(styles);

const MenuSidebarElement = ({
  RouterLink,
  routerMode,
  data,
}) => (
  <div
    data-ppuc-id="MenuSidebar.MenuSidebarElement"
  >
    <RouterLink
      exact={data.exact || false}
      to={data.navigationPath}
      className={
        routerMode === 'legacy'
          ? bindClasses('element')
          : ({ isActive }) => bindClasses('element', { active: isActive })
      }
      activeClassName={
        routerMode === 'legacy'
          ? bindClasses('active')
          : undefined
      }
      isActive={data.isActive}
    >
      <Icon name={data.icon} />
      <Label>{data.text}</Label>
      {data.badge && (
        <div className={bindClasses('badge')}>
          <Badge text={data.badge} size="small" display="block" color="blue" />
        </div>
      )}
    </RouterLink>
  </div>
);

export { MenuSidebarElement };
